export class StockInventoryModel {
    Id:number;
    StockDate:any;
    StockDateISO: string = '';
    StockFileName:string = '';
    StockFilePath:string = '';

}